import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const ResearchRequestSchema = z.object({
  researchRequestId: PrimaryKeySchema,
  projectId: PrimaryKeySchema,
  title: z.string().min(1).max(255),
  description: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ResearchRequest = z.infer<typeof ResearchRequestSchema>;

export const ResearchRequestsSchema = z.array(ResearchRequestSchema);

export type ResearchRequests = z.infer<typeof ResearchRequestsSchema>;

export const ResearchRequestsQuerySchema =
  createOffsetPaginationRequestQuerySchema(
    z.enum(['createdAt', 'updatedAt']),
  ).extend({
    researchRequestIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    projectIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
  });

export type ResearchRequestsQuery = z.infer<typeof ResearchRequestsQuerySchema>;

export const CreateResearchRequestSchema = ResearchRequestSchema.pick({
  projectId: true,
  title: true,
  description: true,
});

export type CreateResearchRequest = z.infer<typeof CreateResearchRequestSchema>;

export const UpdateResearchRequestSchema = z.object({
  // Field updates
  title: ResearchRequestSchema.shape.title.optional(),
  description: ResearchRequestSchema.shape.description.optional(),
  // Triggers
  shouldStart: z.boolean().optional(),
  shouldStop: z.boolean().optional(),
});

export type UpdateResearchRequest = z.infer<typeof UpdateResearchRequestSchema>;

export const ResearchRequestWorkflowStatusSchema = z.object({
  status: z.enum(['idle', 'running', 'completed', 'failed', 'cancelled']),
  lastUpdatedAt: z.coerce.date().optional(),
});

export type ResearchRequestWorkflowStatus = z.infer<
  typeof ResearchRequestWorkflowStatusSchema
>;
